import CartProductSkeletons from '../shared/elements/cartProductSkeleton';
import './index.scss';
import Skeleton from '@mui/material/Skeleton';

const OrderConfirmationSkeleton = () => {
  return (
    <div className="order-summary-details" id="order-container">
      <div className="row gutter-30">
        <div className="order-confirmation__layout">
          <div
            id="order-number"
            className="col-xs-10 col-sm-7 col-md-7 col-lg-7 below-24 title-underline order-confirmation-skeleton-header"
          >
            <Skeleton
              animation="wave"
              variant="rectangular"
              height={48}
              className="skeleton-logo"
            />
            <Skeleton animation="wave" variant="text" className="skeleton-greeting-text" />
            <Skeleton animation="wave" variant="text" className="skeleton-order-text" />
            <Skeleton
              animation="wave"
              variant="text"
              className="skeleton-order-text skeleton-confirmation-text"
            />
          </div>
          <div className="col-sm-6 col-md-5 col-lg-5 payment-box order-confirmation-skeleton-body">
            <div className="summary-order-details" id="summary-order-container">
              <h2 className="mega btm-paddng-12">
                <Skeleton animation="wave" variant="text" className="skeleton-order-summary" />
              </h2>
              <div className="cart-products-wrap">
                <CartProductSkeletons/>
              </div>
              <div id="summary-wrapper">
                <Skeleton
                  animation="wave"
                  variant="text"
                  className="skeleton-order-summary-total-1"
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  className="skeleton-order-summary-total-2"
                />
                <Skeleton
                  animation="wave"
                  variant="text"
                  className="skeleton-order-summary-total"
                />
              </div>
              <div className="address-wrap">
                <div className="address-box">
                  <Skeleton animation="wave" variant="rectangular" height={116} width={196} />
                </div>
                <div className="address-box">
                  <Skeleton animation="wave" variant="rectangular" height={116} width={196} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationSkeleton;
